import { render, staticRenderFns } from "./side_bar.vue?vue&type=template&id=4363564e&scoped=true&"
import script from "./side_bar.js?vue&type=script&lang=js&"
export * from "./side_bar.js?vue&type=script&lang=js&"
import style0 from "./side_bar.vue?vue&type=style&index=0&id=4363564e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363564e",
  null
  
)

export default component.exports